export default function clickToPlayWrap (wrapElement, controls = true) {
  if (!wrapElement) {
    console.error('No provided for clickToPlayWrap()')
    return
  }
  const video = wrapElement.querySelector('video')

  if (!video) {
    console.error('No video element found for clickToPlayWrap(). Wrap element: ', wrapElement)
    return
  }

  video.addEventListener('play', () => {
    wrapElement.classList.add('play')
    controls && video.setAttribute('controls', true)
  })

  video.addEventListener('pause', () => {
    wrapElement.classList.remove('play')
    controls && video.removeAttribute('controls')
  })

  document.addEventListener('click', ({ target }) => {
    const children = Array.from(wrapElement.querySelectorAll('*'))
    if (target === wrapElement || children.includes(target)) return
    video.pause()
  })

  wrapElement.addEventListener('click', ev => {
    ev.preventDefault()

    if (video) {
      if (video.paused) {
        video.play()
      } else {
        video.pause()
      }
    } else {
      console.error('Error: video element is not found')
    }
  })
}
